module.exports = __webpack_public_path__ + "img/ic_datixiangqing.34eee699.svg";